import React from 'react'

import { cn } from '@/lib/utils'

type Props = Omit<React.ComponentProps<'button'>, 'children'> & {
  icon: React.ReactNode
  title: React.ReactNode
  subtitle: React.ReactNode
  isHighlighted?: boolean
  onClick: () => void
}

const AddReferralModalOption: React.FC<Props> = ({
  icon,
  title,
  subtitle,
  isHighlighted,
  onClick,
  className,
  ...props
}) => (
  <button
    className={cn(
      `flex-1 p-4 sm:p-6 border-2 border-border cursor-pointer rounded-lg
      hover-elevate transition-all text-center group hover:bg-gray-100`,
      { 'border-primary/30 bg-primary/3': isHighlighted },
      className,
    )}
    onClick={onClick}
    {...props}
  >
    <div
      className="size-8 sm:size-12 rounded-lg bg-primary/10 flex items-center
        justify-center mx-auto mb-3 group-hover:bg-primary/20 transition-colors"
    >
      {icon}
    </div>
    <p className="font-semibold text-[15px]">{title}</p>
    <p className="text-[11px] text-muted-foreground mt-1">{subtitle}</p>
  </button>
)

export default AddReferralModalOption
